import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

const TEASERS = [
  { cat: "Hair", line: "Last-minute blow-dries, colour & cuts" },
  { cat: "Skin", line: "Facials and glow treatments near you" },
  { cat: "Brows + Lashes", line: "Quick touch-ups before the weekend" },
  { cat: "Wellness", line: "Sauna, bathhouse & contrast sessions" },
];

export function ComingSoonGrid({ heading = "Melbourne is almost ready.", sub = "Our founding studios are loading their first openings now. Join early access from 7 January; public booking requests open 7 February 2027." }) {
  return (
    <div data-testid="coming-soon">
      <div className="max-w-xl mb-8">
        <p className="text-[10px] tracking-[0.3em] uppercase text-mocha">Launching soon</p>
        <h2 className="mt-3 font-serif text-3xl md:text-4xl text-ink leading-tight">{heading}</h2>
        <p className="mt-3 text-[15px] text-ink/60 leading-relaxed">{sub}</p>
        <Link
          to="/join"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-espresso text-bone px-6 py-3 text-sm hover:bg-ink transition-colors"
          data-testid="coming-soon-join"
        >
          Get early access <ArrowRight size={14} strokeWidth={1.5} />
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
        {TEASERS.map((t, i) => (
          <article
            key={t.cat}
            className="relative border border-sand/80 bg-sand/20 aspect-[4/5] flex flex-col justify-between p-5 overflow-hidden"
            data-testid={`coming-soon-card-${i}`}
          >
            <div className="absolute inset-0 fyllr-hero-grain pointer-events-none opacity-40" />
            <div className="flex items-center justify-between">
              <span className="text-[10px] tracking-[0.2em] uppercase text-mocha">{t.cat}</span>
              <Sparkles size={14} className="text-mocha/70" />
            </div>
            <div>
              <p className="font-serif text-2xl text-ink/80 leading-tight">{t.line}</p>
              <span className="mt-4 inline-block text-[10px] tracking-[0.22em] uppercase text-ink/45 border border-sand px-2.5 py-1 rounded-full">
                Coming soon
              </span>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
